import React, { useEffect } from 'react'
import { useState } from 'react'
import '../../GeneralServices/NewConnection/NewConnectionForm.scss'
import { Grid, Box, Button, Typography, TextField, FormControlLabel, FormControl, RadioGroup, Radio } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Error from '../../../components/error/error'
import { dBillAPI, downloadBill } from '../../../services/Functions'
import { useSelector } from 'react-redux'
const DuplicateBill = () => {

    const initialValues = {
        iv_reference_number: '',
        iv_consumer_id: '',
    }
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [searchBy, setSearchBy] = useState('consumerId')
    const [referenceNumber, setReferenceNumber] = useState('')
    const [error, setError] = useState(false);
    const { token } = useSelector((state) => state.auth)
    const SearchBy = (event) => {
        values.iv_search_by = event.target.value;
        setSearchBy(event.target.value);
        values.iv_consumer_id = ''
        values.iv_reference_number = ''
        setError()
        setReferenceNumber('')
    };
    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: Yup.object({
            iv_reference_number: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'referenceNo',
                then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
                otherwise: Yup.string().optional()
            }),
            iv_consumer_id: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'consumerId',
                then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
                otherwise: Yup.string().optional()
            }),
        }),
        onSubmit: async (values, { resetForm }) => {
            if (searchBy === 'consumerId') {
                setViewBackdrop(true)
                downloadBill(referenceNumber)
                setViewBackdrop(false)
            }
            if (searchBy === 'referenceNo') {
                setViewBackdrop(true)
                downloadBill(values.iv_reference_number)
                setViewBackdrop(false)
            }
        }
    })

    const referenceApi = async () => {
        if (searchBy === 'consumerId') {
            setViewBackdrop(true)
            if (!values.iv_consumer_id) return;
            let apiResponse = await dBillAPI(token, values.iv_consumer_id)
            if (apiResponse.status) {
                const basicInfo = apiResponse.basicInfo
                setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
            } else if (apiResponse.status == false) {
                setError('No Data Found against this Customer ID.')
            } else {
                setError('Customer ID. not found!')
            }
            setViewBackdrop(false)
        }
    }

    useEffect(() => {
        if (values.iv_consumer_id.length === 10) {
            referenceApi();
        } else {
            setReferenceNumber('')
            setError('')
        }
    }, [values.iv_consumer_id])

    const errorCloses = () => {
        setError('')
        // setFieldSurveyError('')
    }

    const handleFormKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleSubmit();
        }
    }

    return (
        <>
            <Grid container className='nC'>
                <Box className='nCContainer'>
                    <div className="headingBarDiv">
                        <h3 className="heading">
                            Duplicate Bill
                        </h3>
                    </div>
                    <form className='ncform' onKeyDown={handleFormKeyDown}>
                        <Typography variant="h6" className="groupTitle">
                            <div className="redCell">
                            </div>
                            Connection Details
                        </Typography>
                        <Grid container className='container' >
                            <Grid item xs={3}>
                                <Typography className="fieldLabel"> Search By</Typography>
                                <FormControl className="form-control"  >
                                    <RadioGroup
                                        className="radio-group"
                                        row
                                        name="iv_search_by"
                                        defaultValue={searchBy}
                                        value={searchBy}
                                        onChange={SearchBy}
                                    >
                                        <FormControlLabel
                                            value="consumerId"
                                            className="form-control-label"
                                            control={<Radio />}
                                            label="Customer ID."
                                            name="consumerId"
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            value="referenceNo"
                                            className="form-control-label"
                                            control={<Radio />}
                                            label="Reference No."
                                            name="referenceNo"
                                            labelPlacement="end"
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            {
                                searchBy === 'consumerId' &&
                                <Grid item xs={2}>
                                    <Typography className='fieldLabel' > Customer ID.</Typography>
                                    <TextField
                                        inputProps={{ maxLength: 10 }}
                                        required
                                        type='text'
                                        autoComplete='off'
                                        name="iv_consumer_id"
                                        value={values.iv_consumer_id}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        id="iv_consumer_id"
                                        className='textInputField'
                                    />
                                    <Box className='from-Error'>
                                        {errors.iv_consumer_id && touched.iv_consumer_id ? (errors.iv_consumer_id) : null}
                                    </Box>
                                </Grid>
                            }
                            {
                                searchBy === 'referenceNo' &&
                                <Grid item xs={2}>
                                    <Typography className='fieldLabel' > Reference No.</Typography>
                                    <TextField
                                        inputProps={{ maxLength: 14 }}
                                        required
                                        type='text'
                                        autoComplete='off'
                                        name="iv_reference_number"
                                        value={values.iv_reference_number}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        id="iv_reference_number"
                                        className='textInputField'
                                    />
                                    <Box className='from-Error'>
                                        {errors.iv_reference_number && touched.iv_reference_number ? (errors.iv_reference_number) : null}
                                    </Box>
                                </Grid>
                            }
                        </Grid>
                        <Grid container >
                            <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px' }}>
                                {
                                    error &&
                                    <Error
                                        error={error}
                                        onClose={() => errorCloses()}
                                        backgroundColor="#FFC0CB"
                                        textColor="#bb0303"
                                        iconColor="#bb0303"
                                    />
                                }
                            </Grid>
                        </Grid>

                        <Box sx={{ marginTop: "1%", textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
                            <Button className={(values.iv_reference_number.length === 14 || referenceNumber.length === 14) === false ? 'disabled-button' : 'button'}
                                variant="contained" component="label" onClick={handleSubmit} disabled={(values.iv_reference_number.length === 14 || referenceNumber.length === 14) === false}>
                                Submit
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Grid>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}

export default DuplicateBill
